import { z } from 'zod';

import { BaseStepDefinition } from './BaseStepDefinition';

export const PhoneCallStepDefinition = BaseStepDefinition.extend({
  type: z.literal('phoneCall'),

  phoneCallConfig: z.object({
    recipient: z.union([z.literal('borrower'), z.literal('loanPointOfContact')]),
    script: z.string(),
  }),
});

export type PhoneCallStepDefinition = z.infer<typeof PhoneCallStepDefinition>;
